/**
 * Undo/redo toolbar buttons.
 *
 * Binds click handlers on the #undo-btn and #redo-btn elements and keeps
 * their enabled state in sync with the active Y.UndoManager via the
 * UNDO_STATE_CHANGED event.
 */

import * as undoManager from "../../../engine/core/undo-manager.js";
import { on, Events } from "../../../engine/core/events.js";

let initialized = false;

function applyState() {
  const undoBtn = document.getElementById("undo-btn");
  const redoBtn = document.getElementById("redo-btn");
  if (undoBtn) undoBtn.disabled = !undoManager.canUndo();
  if (redoBtn) redoBtn.disabled = !undoManager.canRedo();
}

export function initUndoRedoToolbar() {
  if (initialized) return;
  initialized = true;

  const undoBtn = document.getElementById("undo-btn");
  const redoBtn = document.getElementById("redo-btn");

  if (undoBtn) {
    undoBtn.addEventListener("click", (e) => {
      e.preventDefault();
      undoManager.undo();
    });
  }
  if (redoBtn) {
    redoBtn.addEventListener("click", (e) => {
      e.preventDefault();
      undoManager.redo();
    });
  }

  on(Events.UNDO_STATE_CHANGED, applyState);
  applyState();
}
